<template>
  <div>
    <LeagueFormatSection />
  </div>
</template>

<script setup lang="ts">
import LeagueFormatSection from '@/components/LeagueFormatSection.vue';

useHead({
  title: 'League Format Explained | The Players League DFW (Bad Boys Tru-Team)',
  meta: [
    { name: 'description', content: "Understand the 'Bad Boys Tru-Team Format' of The Players League DFW, including match structure, player substitutions, timeouts, and team divisions." },
    { property: 'og:title', content: 'League Format Explained | The Players League DFW (Bad Boys Tru-Team)' },
    { property: 'og:description', content: "Understand the 'Bad Boys Tru-Team Format' of The Players League DFW, including match structure, player substitutions, timeouts, and team divisions." },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com/league-format' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'League Format Explained | The Players League DFW (Bad Boys Tru-Team)' },
    { name: 'twitter:description', content: "Understand the 'Bad Boys Tru-Team Format' of The Players League DFW, including match structure, player substitutions, timeouts, and team divisions." },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});

useSchemaOrg([
  defineArticle({
    headline: 'League Format Explained | The Players League DFW (Bad Boys Tru-Team)',
    description: "Understand the 'Bad Boys Tru-Team Format' of The Players League DFW, including match structure, player substitutions, timeouts, and team divisions.",
    image: 'https://www.theplayersleague.net/League-format.png', // Assuming a relevant image exists
    author: {
      name: 'The Players League DFW',
      url: 'https://www.theplayersleague.net'
    },
    publisher: {
      name: 'The Players League DFW',
      logo: 'https://www.theplayersleague.net/TPLDFW-logo.JPEG'
    },
    datePublished: '2024-01-01', // TODO: Update with actual publish date
    dateModified: '2025-06-09' // Current date
  })
])
</script>

<style scoped>
div {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
